import React from 'react'
import { SvgIcon } from '../svg-icon'

/**
 * Define default props as fallback. See SvgIcon base class for propTypes.
 *
 * @static
 * @type {React.defaultProps}
 */
const defaultProps = {
    viewBoxSize: 32
}

/**
 * Stateless function representing a license plate icon.
 *
 * @function
 * @param {Object} [props] The component properties
 * @returns {ReactElement} React component markup
 *
 * @see SvgIcon
 * @example
 * <LicensePlateIcon width={12} />
 */
const LicensePlateIcon = props => (
    <SvgIcon {...props}>
        <path
            d={`M29.444 12.944v8.556c0 0.675-0.548 1.223-1.223
            1.223h-24.444c-0.675 0-1.223-0.548-1.223-1.223v-8.556h-1.221v8.556c0
            1.344 1.1 2.444 2.444 2.444h24.444c1.344 0 2.444-1.1
            2.444-2.444v-8.556h-1.221z`}
        />
        <path
            d={`M28.223 8.056h-24.445c-1.344 0-2.444 1.1-2.444
            2.444v1.223h29.333v-1.223c0-1.344-1.1-2.444-2.444-2.444zM5.612
            10.517h-1.223c-0.336 0-0.611-0.275-0.611-0.611s0.275-0.612
            0.611-0.612h1.223c0.336 0 0.611 0.275 0.611 0.611s-0.275 0.612-0.611
            0.612zM27.611 10.5h-1.223c-0.336 0-0.611-0.275-0.611-0.611s0.275-0.611
            0.611-0.611h1.223c0.336 0 0.611 0.275 0.611 0.611s-0.275 0.611-0.611
            0.611z`}
        />
        <path
            d={`M6.905 17.063l1.249-1.997h0.809l-1.647 2.585
            1.687 2.628h-0.817l-1.281-2.033-1.289
            2.033h-0.813l1.691-2.628-1.651-2.585h0.805l1.257 1.997z`}
        />
        <path
            d={`M11.392 17.681l1.361-2.617h0.78l-1.799
            3.269v1.944h-0.687v-1.944l-1.797-3.269h0.788l1.353 2.617z`}
        />
        <path
            d={`M18.027 20.277h-0.667v-4.415l-1.336
            0.491v-0.601l1.897-0.713h0.104v5.239z`}
        />
        <path
            d={`M23.384 20.277h-3.416v-0.476l1.804-2.005c0.268-0.303
             0.452-0.549 0.553-0.74 0.101-0.189 0.152-0.387 0.152-0.589
             0-0.272-0.083-0.496-0.247-0.669-0.165-0.175-0.384-0.261-0.659-0.261-0.329
             0-0.585 0.093-0.768 0.281s-0.273 0.448-0.273 0.783h-0.664c0-0.48
             0.155-0.868 0.464-1.164s0.723-0.444 1.24-0.444c0.484 0 0.868 0.127
             1.149 0.381s0.423 0.592 0.423 1.015c0 0.513-0.327 1.124-0.981
             1.833l-1.396 1.515h2.617v0.541z`}
        />
        <path
            d={`M25.048 17.349h0.497c0.312-0.005 0.559-0.088
            0.737-0.248s0.268-0.376 0.268-0.648c0-0.611-0.305-0.917-0.913-0.917-0.287
            0-0.515 0.081-0.685 0.245s-0.256 0.38-0.256 0.651h-0.663c0-0.413 0.151-0.756
            0.453-1.029 0.301-0.273 0.685-0.411 1.151-0.411 0.492 0 0.877 0.131
            1.156 0.391s0.419 0.621 0.419 1.084c0 0.227-0.073 0.447-0.22 0.659s-0.347
            0.371-0.6 0.476c0.287 0.091 0.508 0.241 0.664 0.451 0.156 0.211 0.235
             0.467 0.235 0.771 0 0.468-0.153 0.839-0.459 1.113s-0.703 0.412-1.192
             0.412c-0.489 0-0.888-0.132-1.195-0.397s-0.46-0.615-0.46-1.049h0.665c0
             0.275 0.089 0.495 0.268 0.659s0.419 0.247 0.72 0.247c0.32 0 0.564-0.084
             0.733-0.251s0.255-0.407
             0.255-0.72c0-0.303-0.093-0.536-0.279-0.699-0.187-0.163-0.455-0.245-0.805-0.251h-0.497v-0.537z`}
        />
    </SvgIcon>
)

LicensePlateIcon.defaultProps = defaultProps

export { LicensePlateIcon }
